import { MemberType } from '../../enum/EnumRepository';
import { useAuth } from '../useApi/useAuth';
import { useSetting } from '../useApi/useSetting';
import { useIsFromArchitrave } from '../useIsFromArchitrave';
import { usePageOwnerIdentityStore } from '../../store/pageOwnerIdentityStore';

export interface NavItem {
  path: string;
  label: string;
  isVisible: boolean;
}

/** Archive 왼쪽 내비: 표시 여부 + 메뉴 목록 (Fold / Fixed / Mobile) */
export const useArchiveNav = () => {
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { isOwner } = useAuth();
  const { setting } = useSetting();
  const isVisible = !useIsFromArchitrave();
  const canShow = Boolean(isVisible && pageOwner && setting);

  const navItems: NavItem[] = [];
  if (pageOwner && setting) {
    const isGroup = setting.memberType === MemberType.GROUP;
    const isMembersVisible = setting.menuVisible.members !== false;
    navItems.push(
      { path: `/@${pageOwner.handle}/projects`, label: "Projects", isVisible: setting.menuVisible.projects },
      { path: `/@${pageOwner.handle}/works`, label: 'Works', isVisible: setting.menuVisible.works },
      { path: `/@${pageOwner.handle}/texts`, label: 'Texts', isVisible: setting.menuVisible.texts },
      ...(isGroup ? [{ path: `/@${pageOwner.handle}/members`, label: 'Members', isVisible: isMembersVisible }] : []),
      { path: `/@${pageOwner.handle}/about`, label: 'About', isVisible: setting.menuVisible.about },
      { path: `/@${pageOwner.handle}/contact`, label: 'Contact', isVisible: setting.menuVisible.contact },
    );
  }

  return { canShow, isVisible, pageOwner, isOwner, setting, navItems };
};
